export const featureFlags = {
  'Show OG Images': true,
};
